import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Table ordering',
    [ORDER_METHODS.PICKUP]: 'Pickup',
    [ORDER_METHODS.DELIVERY]: 'Delivery',
  },
};
